import { h } from "snabbdom";
import { ELEMENT_TYPE } from "./constants";
import {
  SlateEditor,
  SlateElement,
  SlateTransforms,
  DomEditor,
} from "@wangeditor/editor";
import PlayIcon from "@saas/components/assets/images/wang-editor/play.png";
import DeleteIcon from "@saas/components/assets/images/wang-editor/delete.png";
import LoadingImg from "@saas/components/assets/images/video-loading.gif";
import RefreshImg from "@saas/components/assets/images/wang-editor/refresh.png";
import { uploadFilToCdn } from "@saas/components/src/utils/cos-upload";
// 渲染节点
/**
 * @param elem 标记块元素
 * @param children 元素子节点
 * @param editor 编辑器实例
 * @returns vnode 节点（通过 snabbdom.js 的 h 函数生成）
 */
const renderToELem = (
  elem = {
    markType: "custom",
    time: "",
    imgUrl: "",
    file: "",
    isError: false,
    isLoading: false,
  },
  children,
  editor
) => {
  const { markType, time, imgUrl, file, isError, isLoading, isLoaded } = elem;
  if (!file && !imgUrl) {
    return createErrorElem(elem, children, editor);
  } else if (isLoading) {
    return createLoadingElem(elem, children, editor);
  } else if (isError) {
    return createErrorElem(elem, children, editor);
  } else if (isLoaded) {
    return createLoadedElem(elem, children, editor);
  } else {
    if (
      imgUrl.indexOf("saas-api-1324980469.cos.ap-beijing.myqcloud.com") >= 0
    ) {
      const img = new Image();
      img.src = imgUrl;
      img.onload = () => {
        onSuccess(elem, children, editor);
        return;
      };
      img.onerror = (error) => {
        onError(elem, children, editor);
      };
    } else if (file) {
      uploadFile(file, elem, editor);
    } else if (imgUrl) {
      // 生成blob
      fetch(imgUrl)
        .then((res) => res.blob())
        .then((blob) => {
          // 生成一个文件对象
          const newFile = new File([blob], "image.png", {
            type: blob.type,
          });
          uploadFile(newFile, elem, editor);
        })
        .catch((err) => {
          onError(elem, children, editor);
        });
    }
    onLoading(elem, children, editor);
    return createLoadingElem(elem, children, editor);
  }
};
// 创建图片加载节点
const createImageLoadingNode = (elem, children, editor) => {
  const imgLoadingVnode = h("img", {
    src: LoadingImg,
    alt: "加载中",
    style: {
      width: "50px",
      height: "auto",
    },
  });
  const loadingTextVnode = h(
    // HTML tag
    "span",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: false }, // HTML 属性，驼峰式写法
      style: {
        height: "24px",
        lineHeight: "24px",
        display: "inline-block",
        textAlign: "center",
        fontSize: "12px",
        color: "#86909C",
      },
    },
    "加载中..."
  );
  const vnode = h(
    ELEMENT_TYPE,
    {
      key: new Date().getTime(),
      props: {
        contentEditable: false,
      },
      style: {
        width: "100%",
        maxWidth: "360px",
        height: "152px",
        background: "#f5f7fa",
        borderRadius: "6px",
        border: "1px solid #F2F3F5",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    [imgLoadingVnode, loadingTextVnode]
  );
  return vnode;
};
// 创建图片加载失败节点
const createImageErrorNode = (elem, children, editor) => {
  const imgLoadingVnode = h("img", {
    src: RefreshImg,
    alt: "重新加载",
    style: {
      width: "50px",
      height: "auto",
      cursor: "pointer",
    },
  });
  const loadingTextVnode = h(
    // HTML tag
    "span",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: false }, // HTML 属性，驼峰式写法
      style: {
        height: "24px",
        lineHeight: "24px",
        display: "inline-block",
        textAlign: "center",
        fontSize: "12px",
        color: "#86909C",
        cursor: "pointer",
      },
    },
    "重新加载"
  );
  const vnode = h(
    ELEMENT_TYPE,
    {
      key: new Date().getTime(),
      props: {
        contentEditable: false,
      },
      style: {
        width: "100%",
        maxWidth: "360px",
        height: "152px",
        background: "#f5f7fa",
        borderRadius: "6px",
        border: "1px solid #F2F3F5",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      },
      on: {
        click: () => {
          onReload(elem, children, editor);
        },
      },
    },
    [imgLoadingVnode, loadingTextVnode]
  );
  return vnode;
};
// 创建图片正常加载节点
const createImgLoadedVnode = (elem, children, editor) => {
  const { imgUrl, time } = elem;
  const imageVnode = h(
    // HTML tag
    "img",
    // HTML 属性
    {
      key: new Date().getTime(),
      props: {
        src: imgUrl,
      }, // HTML 属性，驼峰式写法
      style: {
        width: "100%",
        maxWidth: "360px",
        height: "152px",
        objectFit: "cover",
        borderRadius: "6px",
        border: "1px solid #F2F3F5",
        marginTop: "6px",
        cursor: "pointer",
      }, // HTML style ，驼峰式写法
      on: {
        click: () => {
          editor.emit("jumpPlayTime", time);
        },
      },
    }
  );
  return imageVnode;
};
// 失败点击重新加载
const onReload = (elem, children, editor) => {
  const path = DomEditor.findPath(editor, elem);
  const { imgUrl = "", markType = "", file = "", content = "" } = elem;
  SlateTransforms.setNodes(
    editor,
    {
      imgUrl: imgUrl,
      markType: markType,
      file: file,
      time: elem.time,
      children: children,
      isLoaded: false,
      isLoading: false,
      isError: false,
      t: new Date().getTime(),
    },
    {
      at: path,
      mode: "highest",
      voids: true,
    }
  );
};
// 加载失败
const onError = (elem, children, editor) => {
  const path = DomEditor.findPath(editor, elem);
  const { imgUrl, markType, file, time } = elem;
  SlateTransforms.setNodes(
    editor,
    {
      imgUrl: imgUrl,
      markType: markType,
      file: file,
      time: time,
      children: children,
      t: new Date().getTime(),
      isError: true,
      isLoading: false,
      isLoaded: false,
    },
    {
      at: path,
      mode: "highest",
    }
  );
};
// 加载成功
const onSuccess = (elem, children, editor) => {
  const path = DomEditor.findPath(editor, elem);
  const { imgUrl = "", markType = "", file = "", time = "" } = elem;
  SlateTransforms.setNodes(
    editor,
    {
      imgUrl: imgUrl,
      markType: markType,
      file: file,
      time: time,
      children: children,
      isLoaded: true,
      isLoading: false,
      isError: false,
      t: new Date().getTime(),
    },
    {
      at: path,
      mode: "highest",
      voids: true,
    }
  );
};
// loading
const onLoading = (elem, children, editor) => {
  const path = DomEditor.findPath(editor, elem);
  const { imgUrl = "", markType = "", file = "" } = elem;
  SlateTransforms.setNodes(
    editor,
    {
      imgUrl: imgUrl,
      markType: markType,
      file: file,
      time: elem.time,
      children: children,
      isLoading: true,
      isLoaded: false,
      isError: false,
      t: new Date().getTime(),
    },
    {
      at: path,
      mode: "highest",
      voids: true,
    }
  );
};
//
// 创建loading 节点
const createLoadingElem = (elem, children, editor) => {
  const topVnode = createTopNode(elem, children, editor);
  const loadingTextVnode = createImageLoadingNode(elem, children, editor);
  const isDisablsed = editor.isDisabled();
  editor.emit("xhInsertMarkBlockUploadStatus", {
    status: "loading",
    elem,
  });
  const vnode = h(
    ELEMENT_TYPE,
    {
      key: new Date().getTime(),
      props: {
        contentEditable: !isDisablsed,
      },
      style: {
        width: "100%",
        maxWidth: "360px",
        height: "183px",
        display: "block",
        background: "transparent",
        position: "relative",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
    [topVnode, loadingTextVnode]
  );
  return vnode;
};
// 创建加载失败节点
const createErrorElem = (elem, children, editor) => {
  const topVnode = createTopNode(elem, children, editor);
  const errorTextVnode = createImageErrorNode(elem, children, editor);
  const isDisablsed = editor.isDisabled();
  editor.emit("xhInsertMarkBlockUploadStatus", {
    status: "error",
    elem,
  });
  const vnode = h(
    ELEMENT_TYPE,
    {
      key: new Date().getTime(),
      props: {
        contentEditable: !isDisablsed,
      },
      style: {
        width: "100%",
        maxWidth: "360px",
        height: "183px",
        display: "block",
        background: "transparent",
        position: "relative",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
    [topVnode, errorTextVnode]
  );
  return vnode;
};
// 创建加载正常节点
const createLoadedElem = (elem, children, editor) => {
  const topVnode = createTopNode(elem, children, editor);
  const loadedVnode = createImgLoadedVnode(elem, children, editor);
  const isDisablsed = editor.isDisabled();
  editor.emit("xhInsertMarkBlockUploadStatus", {
    status: "loaded",
    elem,
  });
  const vnode = h(
    ELEMENT_TYPE,
    {
      key: new Date().getTime(),
      props: {
        contentEditable: !isDisablsed,
      },
      style: {
        width: "100%",
        maxWidth: "360px",
        height: "183px",
        display: "block",
        background: "transparent",
        position: "relative",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
    [topVnode, loadedVnode]
  );
  return vnode;
};
// 创建标记顶部节点
const createTopNode = (elem, children, editor) => {
  const { markType = "custom", time = "", imgUrl = "" } = elem;
  // const { readOnly = false } = editor.getConfig() || {};
  const showTime = secondsToHms(time);
  const path = DomEditor.findPath(editor, elem);
  let titleColor = "#00C89D";
  const isDisablsed = editor.isDisabled();

  if (markType === "custom") {
    // 自定义
    titleColor = "#00C89D";
  } else if (markType === "key") {
    // 重点
    titleColor = "#FF265C";
  } else if (markType === "question") {
    // 疑问
    titleColor = "#FF7700";
  }
  const playIconVnode = h(
    // HTML tag
    "img",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: {
        contentEditable: false,
        src: PlayIcon,
      }, // HTML 属性，驼峰式写法
      style: {
        width: "12px",
        minHeight: "12px",
        minWidth: "12px",
        height: "12px",
        marginRight: "4px",
        marginLeft: "5px",
      },
    }
  );
  // 时间节点
  const timeVnode = h(
    // HTML tag
    "div",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: false }, // HTML 属性，驼峰式写法
      attrs: {
        class: "qa-time",
      },
      style: {
        minWidth: "72px",
        width: "72px",
        height: "24px",
        marginRight: "6px",
        borderRadius: "6px",
        border: "1px solid #F2F3F5",
        background: "#FFFFFF",
        fontSize: "11px",
        color: "#4E5969",
        lineHeight: "24px",
        cursor: "pointer",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
      },
      on: {
        click: () => {
          editor.emit("jumpPlayTime", time);
        },
        mouseenter: () => {
          // 编辑器聚焦时，点击事件会被编辑器的失焦事件拦截，导致上面的点击事件不触发，所以先手动失焦编辑器
          editor.blur();
        },
      },
    },
    // 子节点
    [playIconVnode, showTime]
  );
  // 标题节点
  const titleVnode = h(
    // HTML tag
    "span",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: !isDisablsed }, // HTML 属性，驼峰式写法
      attrs: {
        class: "qa-title",
      },
      style: {
        height: "24px",
        lineHeight: "24px",
        display: "inline-block",
        borderRadius: "6px",
        border: "1px solid #F2F3F5",
        flex: 1,
        padding: "0 6px",
        color: titleColor,
        overflow: "hidden",
        fontSize: "11px",
        background: "#FFFFFF",
      },
    },
    [
      h(
        "span",
        {
          key: new Date().getTime(),
          props: { contentEditable: false }, // HTML 属性，驼峰式写法
          style: {
            height: "24px",
            display: "inline-block",
          },
        },
        "#"
      ),
      ...children,
    ]
  );
  // 删除按钮
  const deleteVnode = h(
    // HTML tag
    "img",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: {
        src: DeleteIcon,
      }, // HTML 属性，驼峰式写法
      attrs: {
        class: "delete-icon",
      },
      style: {
        width: "16px",
        height: "16px",
        minHeight: "16px",
        minWidth: "16px",
        lineHeight: "24px",
        textAlign: "center",
        cursor: "pointer",
      }, // HTML style ，驼峰式写法
      on: {
        click: () => {
          // if (readOnly) return;
          // 删除当前节点
          SlateTransforms.removeNodes(editor, {
            at: path,
            mode: "highest",
          });
        },
      },
    }
  );
  const topVnode = h(
    // HTML tag
    "div",
    // HTML 属性、样式、事件
    {
      key: new Date().getTime(),
      props: { contentEditable: !isDisablsed }, // HTML 属性，驼峰式写法
      style: {
        width: "100%",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "6px",
      },
    },
    [timeVnode, titleVnode, deleteVnode]
  );
  return topVnode;
};
// 上传图片
const uploadFile = (file, elem, editor, children) => {
  const uploadImageConfig = editor.getMenuConfig("uploadImage");
  // const path = DomEditor.findPath(editor, elem);
  uploadFilToCdn(
    file,
    { type: 104 },
    {
      onSuccess: (res) => {
        const img = new Image();
        img.src = res.url;
        img.onload = () => {
          // onSuccess(elem, children, editor);
          const path = DomEditor.findPath(editor, elem);
          const { imgUrl = "", markType = "", file = "", time = "" } = elem;
          SlateTransforms.setNodes(
            editor,
            {
              imgUrl: res.url,
              markType: markType,
              file: file,
              time: time,
              children: children,
              isLoaded: true,
              isLoading: false,
              isError: false,
              t: new Date().getTime(),
            },
            {
              at: path,
              mode: "highest",
              voids: true,
            }
          );
        };
        img.onerror = (error) => {
          onError(elem, children, editor);
        };
      },
      onError: (err) => {
        onError(elem, children, editor);
      },
      onProgress: (progress) => {
        uploadImageConfig.onProgress(progress);
      },
    }
  );
};
// 秒转时分秒比如 00:00:00
const secondsToHms = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);
  seconds %= 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}:${String(seconds).padStart(2, "0")}`;
};
// 编辑器渲染配置
export const renderToElemConfig = {
  type: ELEMENT_TYPE,
  renderElem: renderToELem,
};
